import { render, staticRenderFns } from "./OrderRejectModal.vue?vue&type=template&id=6c2b28ae&scoped=true&"
import script from "./OrderRejectModal.vue?vue&type=script&lang=js&"
export * from "./OrderRejectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b28ae",
  null
  
)

export default component.exports